<script lang="ts">
import {
  iButton,
  iButtonSizes,
  iButtonTypes,
  iButtonStyles,
  iTooltipAlignmentMode,
  iTooltip,
} from '@inscribe/signal';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'ChatToggleButton',
  components: { iButton, iTooltip },
  props: {},
  setup() {
    return {
      iButtonSizes,
      iButtonTypes,
      iButtonStyles,
      iTooltipAlignmentMode,
    };
  },
  computed: {
    ...mapGetters(['isChatAgentEnabled']),
  },
  methods: {
    ...mapActions(['toggleChat']),
    getKeyboardShortcutLabel() {
      const isMac = navigator.userAgent.includes('Mac');
      return isMac ? '⌘I' : 'Ctrl+I';
    },
    onChatToggleButtonClick(evt) {
      evt.stopPropagation();
      this.toggleChat();
    },
  },
};
</script>

<template>
  <div class="chat-button" v-if="isChatAgentEnabled">
    <i-button
      id="chat-button"
      left-icon="medium_layout_10"
      :size="iButtonSizes.MEDIUM"
      :type="iButtonTypes.NEUTRAL"
      :button-style="iButtonStyles.GHOST"
      @button-click="onChatToggleButtonClick"
    />
    <i-tooltip
      target="#chat-button"
      title="Assistant"
      :alignment="iTooltipAlignmentMode.BOTTOM_RIGHT"
    >
      <template #tools>
        <div class="shortcut i-ml-2 i-text-body-3 i-text-neutral-90">
          {{ getKeyboardShortcutLabel() }}
        </div>
      </template>
    </i-tooltip>
  </div>
</template>

<style lang="scss" scoped>
.shortcut {
  font-family: 'Roboto Mono';
}
</style>
